<template>
  <v-content>
    <v-container>
      <v-card>
        <fma-listing :listing="currentListing" />
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import FmaListing from "@/components/FmaListing.vue";

export default {
  components: {
    FmaListing
  },
  computed: {
    currentListing() {
      return this.$store.state.currentListing;
    }
  },
  mounted() {
    this.$store.dispatch("fetchListing", { id: this.$route.params.id });
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";
</style>
